module.exports = __webpack_public_path__ + "img/vidhyaanLogoNew.52775bb9.png";